export const API_RESPONSE_NO_DATA =
  'No data available for the requested time frame.';
export const API_RESPONSE_ERROR =
  'Something went wrong. Please contact the energybox support team.';
export const SETTINGS_CHARTS_CONNECT_NULLS = 'Hide gaps';
export const SETTINGS_CHARTS_FETCH_DATA_ON_ZOOM = 'Fetch New Data on Zoom';
export const NAV_RANGE_DIALOG_TITLE = 'Select Time Range';

export const NAV_SANKEY_OPTIONS_SHOW_VALUES = 'Show Values';
export const NAV_SANKEY_OPTIONS_SHOW_COSTS = 'Show Costs';
export const NAV_SANKEY_OPTIONS_SHOW_NAMES = 'Show Names';

export const SITE_OVERVIEW_NAV_FLOW_CHART = 'Energyflow Diagram';
export const SITE_OVERVIEW_NAV_CHARTS = 'Charts';
export const SITE_OVERVIEW_HEADLINE = 'Logger View';

export const SITE_OVERVIEW_LOGGER_FLOW_CHART = 'Energyflow View';
export const SITE_OVERVIEW_LOGGER_CHART = 'Chart View';



// WEBPACK FOOTER //
// ./src/constants/actionMessages.js